/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTask.vue?vue&type=template&id=b877b230&scoped=true"
import script from "./popAirdropTask.vue?vue&type=script&lang=js"
export * from "./popAirdropTask.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTask.vue?vue&type=style&index=0&id=b877b230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b877b230",
  null
  
)

export default component.exports